import { ActionReducerMapBuilder, PayloadAction } from "@reduxjs/toolkit";
import { UserState } from "../../Slice/Auth/AuthSlice";
import { getUserByToken } from "../../ApiCalls/Auth/login";
import { getBranchesAPI, createBranchAPI, updateBranchAPI, deleteBranchAPI } from "../../ApiCalls/Dashboard/BranchAPI";
import {
  acceptRedeemContactTermsAPI,
  acceptDashboardTermsAPI,
  getBusinessDetailsAPI,
  updateBusinessDetailsAPI,
  getUserActivePlanAPI,
  updateUserDetailsAPI,
  verifyEmailLinkAPI,
} from "../../ApiCalls/Auth/user";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../components/atoms/Utlis/Toast";
import { ActivePlan } from "../../../Data/subscription.dto";
import { setStoredStudioAccess, clearStoredStudioAccess } from "../../../Utils/permissionUtils";
import { resolveShowRedeemUserMobile } from "../../../Utils/resolveShowRedeemUserMobile";

export const UserReducer = (builder: ActionReducerMapBuilder<UserState>) => {
  builder
    .addCase(getUserByToken.pending, (state) => {
      state.loading = true;
      state.error = {};
    })
    .addCase(getUserByToken.fulfilled, (state, action: PayloadAction<any>) => {
      state.loading = false;
      // console.log("payload")
      // console.log(action.payload)

      const root = action.payload?.user ? action.payload : action.payload?.data ?? action.payload;
      const userPayload = root?.user ?? action.payload?.user;

      if (!userPayload) {
        state.isError = true;
        state.error = {
          status: 400,
          message: "Invalid user details response",
        };
        return;
      }

      if (userPayload.role === null) {
        state.isError = true;
        state.error = {
          status: 402,
          message: "Please Register first",
        };
      } else if (userPayload.role !== 3 && userPayload.role !== 4) {
        state.isError = true;
        state.error = {
          status: 401,
          message: "You are not authorized to perform this action",
        };
      } else if (
        userPayload.role === 4 &&
        !Boolean(
          (action.payload?.studio_access || root?.studio_access)?.studio_role ||
          (Array.isArray((action.payload?.studio_access || root?.studio_access)?.permissions) &&
            (action.payload?.studio_access || root?.studio_access)?.permissions.length > 0) ||
          (action.payload?.studio_access || root?.studio_access)?.is_studio_owner
        )
      ) {
        state.isError = true;
        state.isAuthenticated = false;
        state.user = null;
        state.access_token = null;
        state.refresh_token = null;
        if (localStorage.getItem("access_token")) {
          localStorage.removeItem("access_token");
          localStorage.removeItem("refresh_token");
        }
        localStorage.removeItem("selected_branch_id");
        clearStoredStudioAccess();
        state.error = {
          status: 403,
          message: "No active studio role assigned. Please contact the studio owner.",
        };
      } else {
        console.log('action.payload', action.payload)
        state.business = root?.business ?? action.payload.business;
        const rawUser = userPayload;
        const normalizedImg = rawUser?.image || rawUser?.profile_image || null;
        const normalizedPhone = rawUser?.phone_number || rawUser?.phone || '';
        state.user = {
          ...rawUser,
          image: normalizedImg,
          profile_image: normalizedImg,
          phone_number: normalizedPhone,
          phone: normalizedPhone,
          show_redeem_user_mobile: resolveShowRedeemUserMobile(action.payload),
        };
        if (state.business?.watermark) {
          state.watermark = state.business.watermark;
        } else if (action.payload.business?.watermark) {
          state.watermark = action.payload.business.watermark;
        } else if ((action.payload as any)?.watermark) {
          state.watermark = (action.payload as any).watermark;
        }

        const possibleLogo =
          state.business?.studio_logo ||
          state.business?.studio_logo_link ||
          (action.payload as any)?.business?.studio_logo ||
          (action.payload as any)?.business?.studio_logo_link ||
          (action.payload as any)?.business?.logo ||
          (action.payload as any)?.studio_logo ||
          (action.payload as any)?.studio_logo_link ||
          (action.payload as any)?.data?.studio_logo ||
          (action.payload as any)?.data?.business?.studio_logo ||
          userPayload?.studio_logo ||
          userPayload?.studio_logo_link ||
          userPayload?.image ||
          null;
        if (possibleLogo) {
          state.studio_logo = possibleLogo;
        }
        if (action.payload.studio_access) {
          setStoredStudioAccess(action.payload.studio_access);
        }
        if (action.payload.branches !== undefined) {
          state.branches = Array.isArray(action.payload.branches) ? action.payload.branches : [];
          state.branchesLoaded = true;
        }
        const termsPayload =
          action.payload?.dashboard_terms ||
          root?.dashboard_terms ||
          userPayload?.dashboard_terms ||
          null;
        if (termsPayload) {
          state.dashboard_terms = termsPayload;
        }
        if (action.payload.selected_branch !== undefined) {
          state.selectedBranch = action.payload.selected_branch || null;
          if (action.payload.selected_branch?.id) {
            localStorage.setItem("selected_branch_id", String(action.payload.selected_branch.id));
          } else {
            localStorage.removeItem("selected_branch_id");
          }
        }
        if (userPayload.role === 4) {
          if (userPayload.branch_id || userPayload.branch_name) {
            const assignedBranch = {
              id: userPayload.branch_id,
              branch_name: userPayload.branch_name || "Branch",
            } as any;
            state.selectedBranch = assignedBranch;
            state.branches = [assignedBranch];
            state.branchesLoaded = true;
            if (userPayload.branch_id) {
              localStorage.setItem("selected_branch_id", String(userPayload.branch_id));
            } else {
              localStorage.removeItem("selected_branch_id");
            }
          } else {
            state.selectedBranch = null;
            state.branches = [];
            state.branchesLoaded = true;
            localStorage.removeItem("selected_branch_id");
          }
        }
        state.isUserChanged = false;
        state.access_token = localStorage.getItem("access_token");
        state.refresh_token = localStorage.getItem("refresh_token");
        state.isAuthenticated = true;
        state.apiStatus = true;
      }
    })
    .addCase(getUserByToken.rejected, (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.isError = true;

      // console.log(action.payload);
      state.error = action.payload;
    })
    .addCase(getBusinessDetailsAPI.pending, (state) => {
      state.loading = true;
      state.error = {};
      state.isError = false;
    })
    .addCase(
      getBusinessDetailsAPI.fulfilled,
      (
        state,
        action: PayloadAction<{
          business_details?: {
            website?: string;
            facebook_link?: string;
            insta_link?: string;
            youtube_link?: string;
            watermark_link?: string;
            watermark?: string;
            studio_logo?: string;
            studio_logo_link?: string;
            address?: string;
            studio_name?: string;
            gst_number?: string;
          };
          business?: {
            id?: number;
            studio_name?: string;
            description?: string;
            address?: string;
            website?: string;
            facebook_link?: string;
            insta_link?: string;
            youtube_link?: string;
            watermark?: string;
            studio_logo?: string;
            gst_number?: string;
          };
        }>
      ) => {
        state.loading = false;
        const p: any = action.payload;
        const bd = p?.business_details || p?.business || p?.data?.business || p?.data?.business_details || p?.data || p;
        if (bd && typeof bd === 'object') {
          if (bd.website) state.SocialLinks.website = bd.website;
          if (bd.facebook_link) state.SocialLinks.facebook_link = bd.facebook_link;
          if (bd.insta_link) state.SocialLinks.insta_link = bd.insta_link;
          if (bd.youtube_link) state.SocialLinks.youtube_link = bd.youtube_link;
          if (bd.watermark_link) state.watermark = bd.watermark_link;
          else if (bd.watermark) state.watermark = bd.watermark;
          const logo = bd.studio_logo || bd.studio_logo_link || bd.logo || bd.image;
          if (logo) state.studio_logo = logo;
          state.business = {
            ...(state.business || { id: bd.id || 0 }),
            ...bd,
            ...(bd.address ? { address: bd.address } : {}),
            ...(bd.studio_name ? { studio_name: bd.studio_name } : {}),
            ...(bd.gst_number !== undefined ? { gst_number: bd.gst_number } : {}),
          };
        }
        state.isSocialChanged = false;
      }
    )
    .addCase(
      getBusinessDetailsAPI.rejected,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.isSocialChanged = false;
      }
    )
    .addCase(updateBusinessDetailsAPI.pending, (state) => {
      state.loading = true;
    })
    .addCase(updateBusinessDetailsAPI.fulfilled, (state, action: PayloadAction<any>) => {
      state.loading = false;
      const p: any = action.payload;
      const bd = p?.data?.data || p?.data?.business_details || p?.data || p?.business_details || p?.business || p;
      if (bd) {
        state.business = {
          ...(state.business || { id: bd.id || 0 }),
          ...bd,
          ...(bd.terms_and_conditions !== undefined ? { terms_and_conditions: bd.terms_and_conditions } : {}),
        };
      }
    })
    .addCase(updateBusinessDetailsAPI.rejected, (state, action: PayloadAction<any>) => {
      state.loading = false;
      showErrorToast(action.payload?.message || "Failed to update business details.");
    })
    .addCase(updateUserDetailsAPI.pending, (state) => {
      state.loading = true;
      state.error = {};
      state.isError = false;
    })
    .addCase(
      updateUserDetailsAPI.fulfilled,
      (state, action: PayloadAction<any>) => {
        showSuccessToast("User updated successfully.");
        const p: any = action.payload;
        const rawUser = p?.data?.user || p?.user;
        if (rawUser) {
          const normalizedImg = rawUser?.image || rawUser?.profile_image || null;
          const normalizedPhone = rawUser?.phone_number || rawUser?.phone || '';
          state.user = {
            ...(state.user || {}),
            ...rawUser,
            image: normalizedImg,
            profile_image: normalizedImg,
            phone_number: normalizedPhone,
            phone: normalizedPhone,
          };
          if (rawUser.studio_logo) {
            state.studio_logo = rawUser.studio_logo;
          }
        }
        const b = p?.data?.business || p?.business || p?.data?.business_details || p?.business_details;
        if (b) {
          const logo = b.studio_logo || b.studio_logo_link || b.logo || b.image;
          if (logo) state.studio_logo = logo;
          state.business = {
            ...(state.business || { id: b.id || 0 }),
            ...b,
          };
        }
        if (p?.data?.studio_logo) {
          state.studio_logo = p.data.studio_logo;
        } else if (p?.studio_logo) {
          state.studio_logo = p.studio_logo;
        }
        state.isUserChanged = true;
        state.isSocialChanged = true;
      }
    )
    .addCase(
      updateUserDetailsAPI.rejected,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        // state.isError = true;
        if (action.payload && action.payload.message) {
          showErrorToast(action.payload.message);
        } else {
          console.log(action.payload);
        }
        // // console.log(action.payload);
        // state.error = action.payload;
      }
    )
    .addCase(acceptRedeemContactTermsAPI.pending, (state) => {
      state.loading = true;
      state.error = {};
      state.isError = false;
    })
    .addCase(acceptRedeemContactTermsAPI.fulfilled, (state) => {
      state.loading = false;
      if (state.user) {
        state.user.show_redeem_user_mobile = true;
      }
    })
    .addCase(
      acceptRedeemContactTermsAPI.rejected,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        if (action.payload && action.payload.message) {
          showErrorToast(action.payload.message);
        } else {
          showErrorToast("Could not save Terms & Conditions consent. Try again.");
        }
      }
    )
    .addCase(acceptDashboardTermsAPI.pending, (state) => {
      state.loading = true;
      state.error = {};
      state.isError = false;
    })
    .addCase(acceptDashboardTermsAPI.fulfilled, (state) => {
      state.loading = false;
      if (state.dashboard_terms) {
        state.dashboard_terms.dashboard_terms_accepted = true;
        state.dashboard_terms.dashboard_terms_accepted_at = new Date().toISOString();
      }
    })
    .addCase(acceptDashboardTermsAPI.rejected, (state, action: PayloadAction<any>) => {
      state.loading = false;
      if (action.payload && action.payload.message) {
        showErrorToast(action.payload.message);
      } else {
        showErrorToast("Could not save Terms & Conditions consent. Try again.");
      }
    })
    .addCase(verifyEmailLinkAPI.pending, (state) => {
      state.loading = true;
      state.error = {};
      state.isError = false;
    })
    .addCase(
      verifyEmailLinkAPI.fulfilled,
      (state, action: PayloadAction<any>) => {
        showSuccessToast("Verification email sent successfully.");
        state.loading = false;
      }
    )
    .addCase(
      verifyEmailLinkAPI.rejected,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        // state.isError = true;

        // // console.log(action.payload);
        if (action.payload && action.payload.message) {
          showErrorToast(action.payload.message);
        } else {
          console.log(action.payload);
        }
        // state.error = action.payload;
      }
    )
    .addCase(getUserActivePlanAPI.pending, (state) => {
      state.loading = true;
      state.error = {};
      state.isError = false;
    })
    .addCase(
      getUserActivePlanAPI.fulfilled,
      (
        state,
        action: PayloadAction<{
          active_plans: ActivePlan[];
          expired_plans: ActivePlan[];
          storage: any;
        }>
      ) => {
        if (action.payload.active_plans.length > 0) {
          state.currentActivePlan = action.payload.active_plans[0];
        }
        if (action.payload.expired_plans.length > 0) {
          state.expiredPlan = action.payload.expired_plans;
        }
        if (action.payload.storage) {
          const s = action.payload.storage;
          // API keys end in `_mb` historically; values are GB.
          const planGb = Number(s.plan_limit_mb ?? 0);
          const addonGb = Number(s.addon_storage_mb ?? 0);
          const usedGb = Number(s.used_storage_mb ?? 0);
          const totalGb = Number(s.total_limit_mb ?? planGb + addonGb);
          state.storage = {
            plan_storage: planGb,
            addon_storage: addonGb,
            total_storage: totalGb,
            used_storage: usedGb,
            remaining_storage: Number(
              s.remaining_storage_mb ?? Math.max(0, totalGb - usedGb)
            ),
          };
        }

        console.log("action.payload", action.payload);
        state.loading = false;
        state.isCurrentPlanChanged = false;
      }
    )
    .addCase(
      getUserActivePlanAPI.rejected,
      (state, action: PayloadAction<any>) => {
        state.loading = false;

        state.isCurrentPlanChanged = false;
        // state.isError = true;

        // // console.log(action.payload);
        // state.error = action.payload;
      }
    )
    .addCase(getBranchesAPI.pending, (state) => {
      state.branchesLoading = true;
    })
    .addCase(getBranchesAPI.fulfilled, (state, action: PayloadAction<any>) => {
      state.branchesLoading = false;
      state.branchesLoaded = true;
      const list = Array.isArray(action.payload)
        ? action.payload
        : Array.isArray(action.payload?.data)
        ? action.payload.data
        : Array.isArray(action.payload?.branches)
        ? action.payload.branches
        : [];
      state.branches = list;
    })
    .addCase(getBranchesAPI.rejected, (state) => {
      state.branchesLoading = false;
      state.branchesLoaded = true;
    })
    .addCase(createBranchAPI.fulfilled, (state, action: PayloadAction<any>) => {
      const newBranch = action.payload?.data || action.payload;
      if (newBranch && newBranch.id) {
        const exists = state.branches.some((b) => b.id === newBranch.id);
        if (!exists) {
          state.branches = [...state.branches, newBranch];
        }
      }
      showSuccessToast("Branch created successfully.");
    })
    .addCase(updateBranchAPI.fulfilled, (state, action: PayloadAction<any>) => {
      const updated = action.payload?.data || action.payload;
      if (updated && updated.id) {
        state.branches = state.branches.map((b) => (b.id === updated.id ? { ...b, ...updated } : b));
        if (state.selectedBranch?.id === updated.id) {
          state.selectedBranch = { ...state.selectedBranch, ...updated };
        }
      }
      showSuccessToast("Branch updated successfully.");
    })
    .addCase(deleteBranchAPI.fulfilled, (state, action: PayloadAction<any>) => {
      const deletedId = action.payload?.deletedId ?? action.payload;
      if (deletedId) {
        state.branches = state.branches.filter((b) => b.id !== deletedId);
        if (state.selectedBranch?.id === deletedId) {
          state.selectedBranch = null;
          localStorage.removeItem("selected_branch_id");
        }
      }
      showSuccessToast("Branch deleted successfully.");
    });
  // .addCase(refreshAccessToken.pending, (state) => {

  // })
  // .addCase(refreshAccessToken.fulfilled, (state, action: PayloadAction<any>) => {

  // })
  // .addCase(refreshAccessToken.rejected, (state, action: PayloadAction<any>) => {
  //     console.log(action.payload)
  //     // state.isError = true;

  //     // // console.log(action.payload);
  //     // state.error = action.payload;
  // })
};
